import * as Sentry from '@sentry/react'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
  /** Rendered when an error is caught. Receives the thrown error. */
  fallback: (args: { error: Error; resetError: () => void }) => React.ReactElement
}

/**
 * Wrapper around @sentry/react ErrorBoundary with a simpler render-prop API
 * and consistent showDialog: false policy across L3 apps.
 */
export function SentryErrorBoundary({ children, fallback }: Props) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => fallback({ error: error as Error, resetError })}
      showDialog={false}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
